<template>
  <div class="home">
    <div class="columns">
      <div class="column">
        <h2>קופונים</h2>
      </div>
      <div class="column has-text-left">
        <router-link :to="{name: 'home'}"
        class="nav-btn button">חזור לניהול מנויים</router-link>
      </div>
    </div>

    <div class="cupons">

      <div class="box has-background-light">
      <div class="columns">
        <div class="column is-2">סה"כ: {{total}}</div>

        <div class="column has-text-left">
          <button class="button is-success new-ref-btn"
           @click="createNewCupon">צור קופון חדש</button>
        </div>

      </div>
    </div>
    <cupun-form v-if="$store.state.cuponForm.open"></cupun-form>
    <cupon-list :cupons="cupons"></cupon-list>

    </div>
  </div>
</template>

<script>
import CuponList from "../components/cupons/CuponList";
import CupunForm from "../components/cupons/CuponForm";

export default {
  components: {
    CuponList,
    CupunForm
  },
  methods: {
    getCuponList() {
      this.$store.dispatch("getCupons");
    },

    createNewCupon() {
      this.$store.dispatch("createCupon");
    }
  },

  computed: {
    cupons() {
      return this.$store.state.cupons;
    },
    total() {
      return this.cupons.length;
    }
  },

  created() {
    this.getCuponList();
  }
};
</script>

<style>
</style>
